import { render, staticRenderFns } from "./OrgsFilter.vue?vue&type=template&id=18b18113&scoped=true&"
import script from "./OrgsFilter.vue?vue&type=script&lang=js&"
export * from "./OrgsFilter.vue?vue&type=script&lang=js&"
import style0 from "./OrgsFilter.vue?vue&type=style&index=0&id=18b18113&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b18113",
  null
  
)

export default component.exports